import { render, staticRenderFns } from "./ChangePasswordPopup.vue?vue&type=template&id=844089d4&"
import script from "./ChangePasswordPopup.vue?vue&type=script&lang=ts&"
export * from "./ChangePasswordPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports